<template>
  <highcharts
    :ref="`ascChart${_uid}`"
    class="asc-highchart highcharts"
    constructor-type="chart"
    :options="chartOptions"
  ></highcharts>
</template>

<script>
export default {
  name: 'AscChart',

  props: {
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      chartRef: null,
      chartOptions: this.options,
    }
  },

  watch: {
    options: {
      handler(newObj) {
        this.chartOptions = newObj
      },
      deep: true,
    },
  },

  mounted() {
    this.chartRef = this.$refs[`ascChart${this._uid}`]
  },
}
</script>

<style lang="scss" scoped>
.highcharts {
  width: 100%;
  margin: 0 auto;
}
</style>
